import React, { useEffect } from "react";
import "./App.css";
import { doctorProfile } from "./mockData";
import Header from "./components/Header";
import Hero from "./components/Hero";
import About from "./components/About";
import ClinicalExpertise from "./components/ClinicalExpertise";
import Achievements from "./components/Achievements";
import HospitalAffiliation from "./components/HospitalAffiliation";
import ConditionsTreated from "./components/ConditionsTreated";
import ClinicalInsights from "./components/ClinicalInsights";
import PatientEducationVideos from "./components/PatientEducationVideos";
import Contact from "./components/Contact";
import SEOSection from "./components/SEOSection";
import Footer from "./components/Footer";

function App() {
  useEffect(() => {
    // Update document title for SEO
    document.title = `${doctorProfile.name} - ${doctorProfile.title}`;
    
    // Update meta description
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute(
        'content',
        `Professional medical profile of ${doctorProfile.name}, specializing in Pediatric Hematology, Oncology & BMT in Hyderabad. Expert in CAR-T cell therapy.`
      );
    }
  }, []);

  return (
    <div className="App">
      <Header contactInfo={doctorProfile.contact} />
      <Hero profile={doctorProfile} />
      <About profile={doctorProfile} />
      <ClinicalExpertise expertise={doctorProfile.clinicalExpertise} />
      <Achievements achievements={doctorProfile.achievements} />
      <HospitalAffiliation hospital={doctorProfile.hospitalAffiliation} />
      <ConditionsTreated conditions={doctorProfile.conditionsTreated} />
      <ClinicalInsights content={doctorProfile.clinicalInsights} />
      <PatientEducationVideos content={doctorProfile.patientEducationVideos} />
      <Contact 
        contact={doctorProfile.contact} 
        hospitalName={doctorProfile.hospitalAffiliation.name}
      />
      <SEOSection keywords={doctorProfile.seoKeywords} />
      <Footer profile={doctorProfile} />
    </div>
  );
}

export default App;